import { useEffect, useState } from "react";

export default function MetricTable({ total, distance, races }) {
  const win = races.filter((r) => +r.position === 1);
  const place = races.filter((r) => +r.position <= 3);
  const totalPercent = Math.round((races.length / total) * 100);

  const winPercent = Math.round((win.length / races.length) * 100);
  const winTotalPercent = Math.round((win.length / total) * 100);
  const placePercent = Math.round((place.length / races.length) * 100);
  const placeTotalPercent = Math.round((place.length / total) * 100);

  const [qualification, setQualification] = useState({});

  useEffect(() => {
    Promise.all(
      races.map((r) =>
        fetch(`https://rpi.zed.run/?race_id=${r.raceId}`).then((r) => r.json())
      )
    ).then((res) => {
      setQualification(
        res.reduce((result, race) => {
          result[race.race_id] = race.rpi;
          return result;
        }, {})
      );
    });
  }, [races]);

  return (
    <div style={{ padding: 12, width: "18%" }}>
      <h3>
        {distance} - {totalPercent}%
      </h3>
      <div>
        <h5>
          First: {winPercent}% / {winTotalPercent}%
        </h5>
        <h5>
          Place: {placePercent}% / {placeTotalPercent}%
        </h5>
      </div>
      <table>
        <thead>
          <tr>
            {/* <td>Weather</td>
            <td>Distance</td> */}
            <td>Pos</td>
            <td>Fire?</td>
            <td>Class</td>
            <td>Gate</td>
          </tr>
        </thead>
        <tbody>
          {races
            .sort(
              (a, b) =>
                // a.length !== b.length ? a.length - b.length : +a.gate - +b.gate
                +a.position - +b.position
            )
            .map((r, i) => (
              <tr key={i}>
                {/* <td>{r.weather}</td>
                <td>{r.length}</td> */}
                <td>{r.position}</td>
                <td>
                  {qualification[r.raceId] && qualification[r.raceId][r.horseId]
                    ? "Yes"
                    : "No"}
                </td>
                <td>{r.class}</td>
                <td>{r.gate}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
